import styled from 'styled-components';

import { SecondaryButton, Text } from '../../components';
import Button from '../../components/Button';
import { ThemeProp } from '../../theme/Themes';

export const maxWidth = '480px';

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`;

export const HeaderText = styled(Text)`
  @media (max-width: 32rem) {
    display: none;
  }
`;

export const HeaderButton = styled(SecondaryButton).attrs((props) => ({
  ...props,
  css: {
    ...props.css,
    'margin-left': '$8',
  },
}))``;

export const HorizontalContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: center;
  width: 100%;
`;

export const MainButton = styled(Button).attrs((props) => ({
  ...props,
  css: {
    ...props.css,
    height: '$16',
    marginTop: '$10a',
  },
}))``;

export const ReSendLink = styled(Button).attrs((props) => ({
  ...props,
  css: {
    ...props.css,
    backgroundColor: 'transparent',
    color: '$primary',
    alignSelf: 'center',
    marginTop: '$6',
  },
}))``;

export const FooterInfoContainer = styled.div`
  align-items: baseline;
  display: inline-flex;
  flex-wrap: wrap;
  gap: 0.125rem;
  & > * {
    font-size: 0.75rem;
    font-weight: ${(props: ThemeProp) => props.theme.fontWeight.regular};
  }
  & > ${Text} {
    color: ${(props: ThemeProp) => props.theme.colors.neutrals.c400};
  }
  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    justify-content: center;
  }
`;
